import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';

export class EasmScanConfigurationBaseDataProvider extends BaseWebComponentDataProvider {
  public async getDataForView(): Promise<any> {
    throw new Error('Not implemented');
  }
}
